import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import reminderService from "./reminderService";
import { SuccesType } from "../review/reviewTypes";

interface reminderState {
    loading: boolean;
    error: any | null;
}

const initialState: reminderState = {
    loading: false,
    error: null,
};


export const applyAuthorReminder = createAsyncThunk<
    SuccesType,
    string,
    { rejectValue: string }
>(
    "reminder/applyAuthorReminder",
    async (article_slug: string, { rejectWithValue }) => {
        try {
            const response = await reminderService.applyAuthorReminder(article_slug);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "Error desconocido");
        }
    }
);

export const applyReviewReminder = createAsyncThunk<
    SuccesType,
    { article_slug: string; review_id: number },
    { rejectValue: string }
>(
    "reminder/applyReviewReminder",
    async ({ article_slug, review_id }, { rejectWithValue }) => {
        try {
            const response = await reminderService.applyReviewReminder(article_slug, review_id);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "Error desconocido");
        }
    }
);

export const unexpireArticle = createAsyncThunk<
    SuccesType,
    string,
    { rejectValue: string }
>(
    "reminder/unexpireArticle",
    async (article_slug: string, { rejectWithValue }) => {
        try {
            const response = await reminderService.unexpireArticle(article_slug);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "Error desconocido");
        }
    }
);

export const unexpireReview = createAsyncThunk<
    SuccesType,
    { article_slug: string; review_id: number },
    { rejectValue: string }
>(
    "reminder/unexpireReview",
    async ({ article_slug, review_id }, { rejectWithValue }) => {
        try {
            const response = await reminderService.unexpireReview(article_slug, review_id);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "Error desconocido");
        }
    }
);

export const rejectReview = createAsyncThunk<
    SuccesType,
    { article_slug: string; review_id: number },
    { rejectValue: string }
>(
    "reminder/rejectReview",
    async ({ article_slug, review_id }, { rejectWithValue }) => {
        try {
            const response = await reminderService.rejectReview(article_slug, review_id);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "Error desconocido");
        }
    }
);

export const hideReview = createAsyncThunk<
    SuccesType,
    { article_slug: string; review_id: number },
    { rejectValue: string }
>(
    "reminder/hideReview",
    async ({ article_slug, review_id }, { rejectWithValue }) => {
        try {
            const response = await reminderService.hideReview(article_slug, review_id);
            return response;
        } catch (error: any) {
            return rejectWithValue(error.message || "Error desconocido");
        }
    }
);



const reminderSlice = createSlice({
    name: "reminder",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // applyAuthorReminder
        builder.addCase(applyAuthorReminder.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(applyAuthorReminder.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(applyAuthorReminder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error desconocido";
        });

        // applyReviewReminder
        builder.addCase(applyReviewReminder.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(applyReviewReminder.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(applyReviewReminder.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error desconocido";
        });

        // unexpireArticle
        builder.addCase(unexpireArticle.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(unexpireArticle.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(unexpireArticle.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error desconocido";
        });

        // unexpireReview
        builder.addCase(unexpireReview.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(unexpireReview.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(unexpireReview.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error desconocido";
        });
          // rejectReview
        builder.addCase(rejectReview.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(rejectReview.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(rejectReview.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error desconocido";
        });
          // hideReview
        builder.addCase(hideReview.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(hideReview.fulfilled, (state) => {
            state.loading = false;
        });
        builder.addCase(hideReview.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Error desconocido";
        });
    },
});

export default reminderSlice.reducer;